import { render, staticRenderFns } from "./SimilarItemsFilters.vue?vue&type=template&id=75b60b2f&"
import script from "./SimilarItemsFilters.vue?vue&type=script&lang=js&"
export * from "./SimilarItemsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VContainer,VSlideYReverseTransition})
